import React, { Component } from "react";
import { Link } from "react-router";
import styles from "../css/Main.css";
import Navigation from "../components/Navigation.js";

import photo1 from "../../design/photos/schalen/DSCN0556A.jpg";
import photo2 from "../../design/photos/schalen/_HUM2359.jpg"; // not anymore
import photo3 from "../../design/photos/schalen/_HUM2371.jpg";
import photo4 from "../../design/photos/schalen/_HUM2716 -  aufgehellt.jpg";
import photo5 from "../../design/photos/schalen/Ruoff_091114_0043_V1_h.jpg";
import photo6 from "../../design/photos/schalen/Ruoff_091114_0032_w.jpg";
import photo7 from "../../design/photos/schalen/Ruoff_091114x0053.jpg";
import photo8 from "../../design/photos/schalen/Ruoff_091114x0069.jpg";
import photo9 from "../../design/photos/schalen/Ruoff_091122_0141_V_w.jpg";
import photo10 from "../../design/photos/schalen/Ruoff_091114x0046.jpg";
import photo11 from "../../design/photos/schalen/20211001_120312.jpg";

import arrow from "../../design/photos/arrow.svg";

export default class Schalen extends Component {
	constructor() {
		super();
		this.state = {
			count: 0,
			photocount: 0,
			photo: [photo11, photo1, photo3, photo4, photo5, photo7, photo9, photo10],
			what: [
				"Porzellan",
				"Porzellan und Steinzeug schamottiert",
				"Porzellan z.T. mit Sand",
				"Porzellan z.T. eingefärbt",
				"Holzofenbrand",
				"Holzofenbrand",
				"Porzellan",
				"Steinzeug"
			],
			size: [
				"H 8 cm, D 9 cm",
				"H 12 cm, D 13 cm",
				"",
				"H 5-6 cm D 5 cm",
				"H 19 cm, D 34 cm",
				"H 10 cm, D 8.5 cm",
				"H 21 cm, D 38 cm",
				"H 15 cm, D 27 cm"
			],
			photographer: [
				"Foto: HS",
				"Foto: HS",
				"Foto: Tobias Humm",
				"Foto: Tobias Humm",
				"Foto: Kaspar Ruoff",
				"Foto: Kaspar Ruoff",
				"Foto: Kaspar Ruoff",
				"Foto: Kaspar Ruoff"
			]
		};
	}

	getImage() {
		return (
			<button onClick={() => this.bigPicture()} className={styles.button2}>
				<img
					alt={10}
					className={styles.photoSideshow}
					src={this.state.photo[this.state.photocount]}
				/>
			</button>
		);
	}

	bigPicture() {
		this.setState({ count: 2 });
	}

	backToSlideshow() {
		this.setState({ count: 1 });
	}

	increment() {
		if (this.state.photocount === 6) {
			this.setState({ photocount: 0 });
		} else {
			this.setState({ photocount: this.state.photocount + 1 });
		}
	}

	decrement() {
		if (this.state.photocount === 0) {
			this.setState({ photocount: 6 });
		} else {
			this.setState({ photocount: this.state.photocount - 1 });
		}
	}

	handleClick(a) {
		if (this.state.count === 0) {
			this.setState({ count: 1 });
			this.setState({ photocount: a });
		} else {
			this.setState({ count: 0 });
		}
	}

	render() {
		if (this.state.count === 0) {
			return (
				<div className={styles.container}>
					<div className={styles.header}>
						<p className={styles.titleleft}>Hanna Schneider</p>
						<p className={styles.titleright}>Keramik</p>
					</div>
					<div className={styles.content}>
						<div className={styles.row1}>
							<button
								onClick={() => this.handleClick(0)}
								className={styles.button}
							>
								<img alt={1} className={styles.photos} src={photo11} />
							</button>
							<button
								onClick={() => this.handleClick(4)}
								className={styles.button2}
							>
								<img alt={1} className={styles.photos} src={photo5} />
							</button>
						</div>

						<div className={styles.row1}>
							<button
								onClick={() => this.handleClick(1)}
								className={styles.button}
							>
								<img alt={1} className={styles.photos} src={photo1} />
							</button>
							<button
								onClick={() => this.handleClick(5)}
								className={styles.button2}
							>
								<img alt={1} className={styles.photos} src={photo7} />
							</button>
						</div>

						<div className={styles.row1}>
							<button
								onClick={() => this.handleClick(2)}
								className={styles.button}
							>
								<img alt={1} className={styles.photos} src={photo3} />
							</button>
							<button
								onClick={() => this.handleClick(6)}
								className={styles.button2}
							>
								<img alt={1} className={styles.photos} src={photo9} />
							</button>
						</div>

						<div className={styles.row1}>
							<button
								onClick={() => this.handleClick(3)}
								className={styles.button}
							>
								<img alt={1} className={styles.photos} src={photo4} />
							</button>
							<button
								onClick={() => this.handleClick(7)}
								className={styles.button2}
							>
								<img alt={1} className={styles.photos} src={photo10} />
							</button>
						</div>
					</div>
					<Navigation />
				</div>
			);
		}
		if (this.state.count == 1) {
			return (
				<div className={styles.container}>
					<div className={styles.header}>
						<p className={styles.titleleft}>Hanna Schneider</p>
						<p className={styles.titleright}>Keramik</p>
					</div>
					<div className={styles.sideShowContainer}>
						<div className={styles.sideshowArea}>
							<button
								className={styles.buttonSideshow}
								onClick={() => this.decrement()}
							>
								<img alt={10} className={styles.imgSideshow} src={arrow} />
							</button>
							{this.getImage()}
							<button
								className={styles.buttonSideshow}
								onClick={() => this.increment()}
							>
								<img alt={10} className={styles.imgSideshow2} src={arrow} />
							</button>
						</div>
						<div className={styles.footer}>
							<div className={styles.descriptionArea}>
								<Link className={styles.link} to="arbeiten">
									<button
										className={styles.back}
										onClick={() => this.handleClick(0)}
									>
										Zurück
									</button>
								</Link>
							</div>
							<div className={styles.descriptionArea}>
								<p className={styles.description}>
									{this.state.what[this.state.photocount]}
								</p>
								<p className={styles.description}>
									{this.state.size[this.state.photocount]}
								</p>
								<p className={styles.description}>
									{this.state.photographer[this.state.photocount]}
								</p>
							</div>
						</div>
					</div>
				</div>
			);
		}
		return (
			<div className={styles.bigImageArea}>
				<div className={styles.imageContainer}>
					<img
						className={styles.bigImage}
						alt={10}
						src={this.state.photo[this.state.photocount]}
					/>
				</div>
				<button
					className={styles.bigBack}
					onClick={() => this.backToSlideshow()}
				>
					{" "}
					Zurück{" "}
				</button>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Schalen.js